var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconTailoredReport = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "report-b",
    width: 46.589,
    height: 63.172,
    viewBox: "0 0 46.589 63.172",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1059",
    "data-name": "Path 1059",
    d: "M66.841,54.032,52.321,56.84,37.8,54.032A9.741,9.741,0,0,1,47.539,44.6H57.19A9.722,9.722,0,0,1,66.841,54.032Z",
    transform: "translate(-29.026 -25.824)",
    fill: "#333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1060",
    "data-name": "Path 1060",
    d: "M61.482,4.2A7.3,7.3,0,1,1,54.2,11.526,7.264,7.264,0,0,1,61.482,4.2Z",
    transform: "translate(-38.232 -3.147)",
    fill: "#333"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_828",
    "data-name": "Group 828",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1061",
    "data-name": "Path 1061",
    d: "M18.634,83.349l22.2,4.3h.439l22.242-4.3a1.073,1.073,0,0,0,.877-1.009V51.193a1.069,1.069,0,0,0-1.272-1.009L56.58,51.456A10.8,10.8,0,0,0,45.92,42.2H36.269a10.8,10.8,0,0,0-10.66,9.256l-6.537-1.272a1.037,1.037,0,0,0-.877.219.938.938,0,0,0-.395.79V82.3A1.045,1.045,0,0,0,18.634,83.349Zm37.2-29.656,6.449-1.228V81.419l-20.18,3.9V56.37l13.731-2.676ZM36.269,44.262H45.92a8.775,8.775,0,0,1,8.6,7.546L41.095,54.4,27.671,51.807a8.741,8.741,0,0,1,8.6-7.546Zm-16.407,8.2,20.18,3.9V85.323l-20.18-3.9Z",
    transform: "translate(-17.8 -24.477)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1062",
    "data-name": "Path 1062",
    d: "M27.916,76.745l14.126,2.676a1.05,1.05,0,1,0,.395-2.062L28.311,74.683a1.05,1.05,0,0,0-.395,2.062Z",
    transform: "translate(-23.003 -42.702)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1063",
    "data-name": "Path 1063",
    d: "M42.437,86.559,28.311,83.883a1.05,1.05,0,1,0-.395,2.062l14.126,2.676a1.077,1.077,0,0,0,1.228-.834A1.022,1.022,0,0,0,42.437,86.559Z",
    transform: "translate(-23.003 -47.866)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1064",
    "data-name": "Path 1064",
    d: "M27.916,95.145l14.126,2.676a1.05,1.05,0,1,0,.395-2.062L28.311,93.083a1.05,1.05,0,1,0-.395,2.062Z",
    transform: "translate(-23.003 -53.03)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1065",
    "data-name": "Path 1065",
    d: "M27.916,104.345l14.126,2.676a1.05,1.05,0,1,0,.395-2.062l-14.126-2.676a1.05,1.05,0,0,0-.395,2.062Z",
    transform: "translate(-23.003 -58.194)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1066",
    "data-name": "Path 1066",
    d: "M42.437,114.159l-14.126-2.676a1.05,1.05,0,0,0-.395,2.062l14.126,2.676a1.077,1.077,0,0,0,1.228-.834A1.043,1.043,0,0,0,42.437,114.159Z",
    transform: "translate(-23.003 -63.358)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1067",
    "data-name": "Path 1067",
    d: "M42.437,123.359l-14.126-2.676a1.05,1.05,0,0,0-.395,2.062l14.126,2.676a1.077,1.077,0,0,0,1.228-.833A1.043,1.043,0,0,0,42.437,123.359Z",
    transform: "translate(-23.003 -68.522)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1068",
    "data-name": "Path 1068",
    d: "M60.135,18.47A8.335,8.335,0,1,0,51.8,10.135,8.331,8.331,0,0,0,60.135,18.47Zm0-14.565a6.229,6.229,0,1,1-6.229,6.229A6.253,6.253,0,0,1,60.135,3.906Z",
    transform: "translate(-36.884 -1.8)",
    fill: "#333"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconTailoredReport, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-tailored-report.cb21f531.svg";
export { ForwardRef as ReactComponent };